import { forAllCallback } from "kwp-core/scripts/utils/helpers";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
    forAllCallback(".content-block.content-block--card-deck", (el) => {
        const elId = el.getAttribute("id");

        const init = () => {
            const cards = el.querySelectorAll(".card");

            if (!cards) return;

            const offsetPosition = window.innerWidth < 1023 ? 25 : 50;

            const tween = gsap.from(`#${elId} .card`, {
                x: offsetPosition,
                y: offsetPosition,
                opacity: 0,
                duration: 0.5,
                stagger: 0.2,
            });
            ScrollTrigger.create({
                trigger: `#${elId}`,
                start: "top bottom",
                end: "bottom top",
                animation: tween,
                once: true,
            });
        };

        init();
    });
};
